import { Injectable, inject } from '@angular/core';
import { HdBodygraphCenter } from '../hd-bodygraph.models';
import { HdContentLanguageService } from '../hd-content-language.service';
import { HdCenterInfoSection } from './hd-center-info-content.manifest';

const HD_CENTERS_ASSET_BASE = '/assets/docs/human-design/centers';
const HD_CENTER_MARKDOWN_LANGUAGES = new Set(['nl', 'en']);

@Injectable({ providedIn: 'root' })
export class HdCenterInfoService {
  private readonly contentLanguage = inject(HdContentLanguageService);

  overviewMarkdownUrl(lang?: string): string {
    return `${HD_CENTERS_ASSET_BASE}/${this.resolveMarkdownLanguage(lang)}/overview.md`;
  }

  centerMarkdownUrl(
    center: HdBodygraphCenter,
    section: HdCenterInfoSection,
    lang?: string,
  ): string {
    return `${HD_CENTERS_ASSET_BASE}/${this.resolveMarkdownLanguage(lang)}/${center}/${section}.md`;
  }

  private resolveMarkdownLanguage(lang?: string): string {
    const requestedLanguage = lang ?? this.contentLanguage.effectiveLang();
    const normalizedLanguage = (requestedLanguage || '').toLowerCase().split('-')[0];
    return HD_CENTER_MARKDOWN_LANGUAGES.has(normalizedLanguage) ? normalizedLanguage : 'nl';
  }
}
